<div class="row mb-4">
  <div class="col-md-12 title-page">
    <h2>Horário de Atendimento</h2>
  </div>
</div>

<div class="card content">
  <form [formGroup]="realDeskForm">
    <div class="row">
      <div class="col-md-12">
        <label>
          <input type="checkbox" formControlName="utilizarHorarioAtendimento"> Utilizar horário de atendimento
        </label>
      </div>
    </div>
    
    <div *ngIf="realDeskForm.controls['utilizarHorarioAtendimento'].value">
      <div class="row">
        <div class="col-md-12">
          <label for="fusoHorario">Fuso horário</label>
          <select class="form-control" formControlName="fusoHorario">
            <option value="America/Sao_Paulo">(UTC-03:00) Horário de Brasília (São Paulo)</option>
            <option value="America/Manaus">(UTC-04:00) Manaus</option>
            <option value="America/Cuiaba">(UTC-04:00) Cuiabá</option>
            <option value="America/Porto_Velho">(UTC-04:00) Porto Velho</option>
            <option value="America/Boa_Vista">(UTC-04:00) Boa Vista</option>
            <option value="America/Rio_Branco">(UTC-05:00) Rio Branco</option>
            <option value="America/Noronha">(UTC-02:00) Fernando de Noronha</option>                 
          </select>
          <small>Defina qual é o fuso-horário utilizado pela pessoa selecionada.</small>
        </div>
      </div>

      <div class="horario-container">
        <div class="dias-grid">
          <div *ngFor="let dia of dias; let i = index" class="dia-card">
            <div class="dia-header">{{ dia }}</div>
            
            <div formArrayName="horarios" class="horario-list">
              <div [formArrayName]="i">
                <div *ngFor="let horario of getHorariosDoDia(i).controls; let j = index" [formGroupName]="j" class="horario-item">
                  <div class="horario-content">
                    <input type="time" class="form-control" formControlName="inicio">
                    <input type="time" class="form-control" formControlName="fim">
                  </div>
                  <button type="button" class="remove-button" (click)="removeHorario(i, j)">✖</button>
                </div>
        
                <button type="button" class="add-button" (click)="addHorario(i)">
                  + Adicionar horário
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-actions mt-4">
      <button type="button" class="btn btn-secondary" (click)="cancel()">Cancelar</button>
      <button type="button" class="btn btn-primary" (click)="save()" [disabled]="isLoading">
        {{ isLoading ? 'Salvando...' : 'Salvar' }}
      </button>
    </div>
  </form>
</div> 